/* Fiche livre : « Voir les autres avis » (progressive disclosure).
   Sans JavaScript, tous les avis restent affichés. Avec JavaScript : les avis au-delà des trois premiers sont repliés derrière un bouton
   (aria-expanded, aria-controls) ; à l'ouverture le focus passe au premier avis révélé, à la fermeture il reste sur le bouton ; mouvement réduit : pas de transition (CSS). */
(function () {
  function init(root) {
    root.querySelectorAll('[data-lec-toggle]').forEach(function (btn) {
      if (btn.dataset.lecInit) return;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.dataset.lecInit = '1';
      var first = panel.querySelector('.lec-list--more');
      function set(open, fromUser) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore;
        panel.classList.toggle('is-collapsed', !open);
        if (open) { panel.removeAttribute('inert'); } else { panel.setAttribute('inert', ''); }
        if (fromUser && open && first) first.focus();
        if (fromUser && !open) btn.focus({ preventScroll: true });
      }
      btn.hidden = false;
      set(false, false);
      btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true', true); });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
